/**
 * ClawInstall admin Dashboard route — eager twin (CLA-958).
 *
 * The Dashboard now renders the frozen design console (`AdminDashboard`: the
 * rail + "Acquisition" topbar shell), so mounting it inside the zinc
 * `/clawinstall/admin` layout's `<Outlet />` would double the chrome. This route
 * lives under `admin_/` — TanStack's trailing-underscore escape keeps the
 * `/clawinstall/admin` URL while opting OUT of that layout — and re-applies the
 * SAME admin gate here so a non-admin who reaches the URL is bounced rather than
 * shown the console (the reseller-admin precedent, `admin_/resellers/route.tsx`).
 *
 * The `beforeLoad` guard runs server-side (it constructs an RPC client and reads
 * the request cookie); the page component and its atom/design imports are
 * deferred to `index.lazy.tsx` so they never land in the always-loaded `main`
 * chunk.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { requireAdmin } from "~/lib/server-admin.ts";

export const Route = createFileRoute("/clawinstall/admin_/")({
  // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
  beforeLoad: async () => {
    // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
    const auth = await requireAdmin();
    return { auth };
  },
});
